<template>
  <!-- 顶部导航栏 -->
  <div class="top">
    <div class="nav">
      <ul class="username">
        <li v-if="username"
            style="display: flex;">
          <div @mouseenter="showUserInfo(true)"
               @mouseleave="showUserInfo(false)">
            <span style="margin-right:5px;cursor: pointer;"
                  @click="goUserInfo">您好，{{username}}</span>
            <Icon type="ios-arrow-down"></Icon>
            <div class="account_admin"
                 v-if="showUser">
              <span style="display: inline-block;">
                <router-link class="pointer" style="padding: 0;"
                             :to="{path: '/user/menuLayout/essentialInfo'}">账号管理
                </router-link>
                <Divider type="vertical" />
                <span style="cursor: pointer"
                      @click="signOut">退出</span>
              </span>
              <Row class="account_main"
                   type="flex">
                <Col>
                <img class="my_icon"
                     alt='用户头像'
                     :src="common.showPic(usericon)"
                     :onerror="common.defaultAvatar()">
                </Col>
                <Col>
                <p @click="goUserInfo">Hi，{{username}}</p>
                <!-- <p>{{levelName}}</p> -->
                </Col>
              </Row>
            </div>
          </div>
          <span @click="goMessage"
                style="cursor:pointer;margin-left: 10px;">消息
            <Badge :count="Number(messagenum)"
                   overflow-count="99"
                   :show-zero="true"
                   type="primary"></Badge>
          </span>
        </li>
        <li v-else>
          <span class="mr_10 pointer"
                @click="goNewPage('/login')">您好，请登录
          </span>
          <span class="pointer" @click="goRegister">免费注册</span>
          <!--          <router-link :to="{name: 'register'}">免费注册</router-link>-->
        </li>
      </ul>
      <ul>
        <li>
          <span class="mr_20 pointer"
                @click="goPage('')">鞋库网</span>
        </li>
        <li>
          <span class=" mr_20 pointer"
                @click="goNewPage('/user/userIndex')">买家工作台</span>
        </li>
        <li>
          <span class="mr_10 pointer"
                @click="goNewPage('/user/cartList')">进货单
            <Badge :count="Number(cartnum)"
                   overflow-count="99"
                   type="primary"
                   :show-zero="true"></Badge>
          </span>
        </li>
        <li>
          <Dropdown class="help">
            <a href="javascript:void(0)"
               class="mr_10 pointer">
              收藏夹
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem>
                <span @click="goNewPage('/user/menuLayout/collectGoods')">收藏商品</span>
              </DropdownItem>
              <DropdownItem>
                <span @click="goNewPage('/user/menuLayout/collectShops')">收藏店铺</span>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </li>
        <li>
          <span class="mr_20 pointer"
                @click="goAdmin">卖家工作台</span>
        </li>
        <li>
          <span class="mr_20 pointer"
                @click="goSupplier">商家入驻</span>
        </li>
        <li>
          <span class="mr_10 pointer"
                @click="goPage('/serviceMarket/index')">服务市场</span>
        </li>
        <li>
          <Dropdown class="help">
            <a href="javascript:void(0)"
               class="mr_10">
              联系客服
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="(item,index) in serviceList"
                            :key="index">
                <div ></div>
                <div style="display: flex;align-items: center;" v-html="item.name">

<!--                  <a style="padding: 0;"
                     :href="item.value"
                     target="_blank">
                    {{item.value}}
                    &lt;!&ndash;                  <img style="width: 18px;" src="@/assets/images/bindingQQ.png" alt="">&ndash;&gt;
                  </a>-->
                </div>
              </DropdownItem>
              <DropdownItem v-if="servicePhone">
                热线：
                <a style="padding: 0;"
                   :href="'tel:' + servicePhone">{{servicePhone}}</a>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </li>
        <li>
          <span class="pointer" @click="goPage('/help')">帮助中心</span>
        </li>
        <li style="margin-left: 10px">
          <a href="javascript:translate.changeLanguage('chinese_simplified');" class="ignore">简体中文</a>
          |
          <a href="javascript:translate.changeLanguage('english');" class="ignore">English</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { configData } from '@/api/index'
import { accountHome } from '@/api/user.js'
export default {
  name: 'TopNav',
  data () {
    return {
      showUser: false,
      serviceList: [],
      servicePhone: null,
      levelName: null,
      nickName: null
    }
  },
  mounted () {
    // =================
    /*const translateScript = document.createElement('script')
    translateScript.src = 'https://res.zvo.cn/translate/translate.js'
    translateScript.language = 'JavaScript'
    document.body.appendChild(translateScript)*/
    this.init()
    //this.translateIn();
  },
  methods: {
    // 跳转个人中心
    goUserInfo () {
      this.$router.push({ name: 'userIndex' })
    },
    init () {
      if (localStorage.getItem('token')) {
        accountHome().then(res => {
          this.levelName = res.data.levelName
        })
      }
      configData({ key: 'P_serviceQQ', tips: '客服qq' }).then(res => {
        let value = res.data.name
        if (value) {
          value = value.split(/,|，/g)
          this.serviceList = value.map(item => {
            let arr = item.split('|')
            return { name: arr[0], value: arr[1] }
          })
        }
      })
      configData({ key: 'P_servicePhone', tips: '客服电话' }).then(res => {
        this.servicePhone = res.data.name
      })
      this.languageReload()
    },
     goUrl(url){
       var lang = translate.language.getCurrent();
       if(lang == 'english'){
         var n = "?";
         if(url.includes("?")){
           n="&";
         }
         window.location.href=this.DOMAIN_URL+url+n+"lang=english";
       }else{
         window.location.href=this.DOMAIN_URL+url;
       }
     },
    languageReload(){
      let lang = this.$route.query.lang
      if(lang == 'english'){
        //console.log("englist_show")
        let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 先拷贝一个一模一样的对象
        delete newQuery.lang //再删除page
        this.$router.replace({ query: newQuery })
        console.log("english_show",this.$route.query.lang);
        translate.language.clearCacheLanguage();
        translate.changeLanguage('english');
        //this.showCountry = true

      }
    },
    translateIn(){
      translate.service.use('client.edge');
      //let lang = translate.language.getCurrent();
      //translate.language.setUrlParamControl('lang');
      /* if(this.$route.query.lang !== 'undefined' && this.$route.query.lang == 'english'){
         if(lang != this.$route.query.lang){
           console.log("2english=")
           translate.language.setLocal('english');

           /!*translate.changeLanguage('english');*!/
         }else{
           console.log("2english!")
           translate.changeLanguage('english');

         }
       }else{
         translate.language.setLocal('chinese_simplified');
       }*/
      translate.language.setDefaultTo('english');

      translate.listener.start();    //开启html页面变化的监控，对变化部分会进行自动翻译。注意，这里变化区域，是指使用 translate.setDocuments(...) 设置的区域。如果未设置，那么为监控整个网页的变化
      translate.selectLanguageTag.show = false;
      translate.execute();
    },
    showUserInfo (value) {
      this.showUser = value
    },

    // 退出账号
    signOut () {
      this.$store.dispatch('LogOut')
      window.open(this.DOMAIN_URL, '_self')
    },
    goMessage () {
      var lang = translate.language.getCurrent();
      if(lang == 'english'){
        this.$router.push({ path: '/user/menuLayout/centerMessage?lang=english' })
      }else{
        this.$router.push({ path: '/user/menuLayout/centerMessage' })
      }
      // 消息中心

    },
    getNotice () {
      this.$Message.info('正在完善中')
    },
    goAdmin () {
      // 前往卖家工作台
      if (!this.$store.state.token) {
        window.open(this.ADMIN_URL + '/#/login', '_blank')
      } else {
        window.open(this.ADMIN_URL + '/#/login?t=' + this.$store.state.token, '_blank')
      }

    },
    goSupplier () {
      // 前往入驻申请
      if (!this.$store.state.token) {
        window.open(this.ADMIN_URL + '/#/login', '_self')
      } else {
        window.open(this.ADMIN_URL + '/#/login?t=' + this.$store.state.token, '_self')
      }
    },
    goPage (page) {
      // 前往页面
      window.open(this.DOMAIN_URL + page, '_self')

    },
    goNewPage (page) {
      // 前往页面
      var lang = translate.language.getCurrent();
      if(lang == 'english'){
        var n = "?";
        if(page.includes("?")){
          n="&";
        }
        window.open(this.DOMAIN_USER_URL + page+n+"lang=english", '_self')

      }else{
        window.open(this.DOMAIN_USER_URL + page, '_self')

      }

    },
    goRegister () {
      // 前往注册
      console.log("注册地址"+this.$store.state.isRegister);
      if (this.$store.state.isRegister == 0) {
        this.$Message.warning('注册通道关闭，请联系客服')
        return
      }
      // 前往页面
      var lang = translate.language.getCurrent();
      if(lang == 'english'){
        window.open(this.DOMAIN_USER_URL + '/register?lang=english', '_self')

      }else{
        window.open(this.DOMAIN_USER_URL + '/register', '_self')

      }

    }
  },
  computed: {
    ...mapState(['username', 'cartnum', 'usericon', 'messagenum'])
  }
}
</script>

<style lang="less" scoped>
@import "../../../my-theme/index.less";

.top {
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  width: 100%;
  background-color: #f5f5f5;
}
.pointer{
  cursor:pointer;
}
.nav {
  margin: 0 auto;
  padding: 0 10px;
  width: 75%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 34px;
}

.nav ul {
  list-style: none;
}

.nav li {
  float: left;
  /*line-height: 34px;*/
}

.nav a,
.nav p {
  text-decoration: none;
  color: #666666;
  padding: 0 10px;
  cursor: pointer;
}

.username a {
  border-left: none;
}

.nav a:hover,
.nav span:hover {
  color: @primary-color;
}

.username {
  color: #666666;

  li:first-child {
    position: relative;
    .account_admin {
      text-align: right;
      padding: 5px 20px 20px;
      width: 250px;
      position: absolute;
      top: 30px;
      left: 0;
      right: 0;
      z-index: 99;
      background: #fff;
      -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    }

    .account_main {
      align-items: center;
      .my_icon {
        width: 52px;
        height: 52px;
        border-radius: 50%;
      }
    }
  }
}
</style>
<style>
.nav ul li .ivu-badge-count {
  line-height: 13px;
  transform: scale(0.84, 0.84);
  font-size: 10px;
}
</style>
